module.exports = __webpack_public_path__ + "static/media/00FFE8.25f1bd32.svg";